


















import { Component, Vue } from "vue-property-decorator";
import { deleteContentTemplate } from "@/services/contentTemplates/contentTemplateService";

@Component
export default class ContentTemplateDeleteModal extends Vue {
    contnetTemplateToBeDeleted: string = "";
    contentTemplateName: string = ""
    isSaved: boolean = false;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") this.confirm();
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
    }

    open(id: string, name: string) {
        this.contnetTemplateToBeDeleted = id;
        this.contentTemplateName = name;
        this.$bvModal.show("modal-deleteContentTemplate");
        window.addEventListener("keydown", this.handleEnter);
    }

    decline() {
        this.$bvModal.hide("modal-deleteContentTemplate");
        this.contnetTemplateToBeDeleted = "";
        this.contentTemplateName = "";
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        deleteContentTemplate(this.contnetTemplateToBeDeleted).then(() => {
            this.$emit("reload");
            this.contnetTemplateToBeDeleted = "";
            this.contentTemplateName = "";
            this.$bvModal.hide("modal-deleteContentTemplate");
        });
    }
}
